import { storyblokEditable } from "@storyblok/react";
import { Link } from "react-router-dom";
import {
  ChevronDown,
  CalendarRange,
  Bike,
  Cog,
  Award,
  ChevronsLeftRightEllipsis,
  FoldHorizontal,
} from "lucide-react";

const MenuLink = ({ blok, setShowMobile }) => {
  if (blok.link.story.name === "Solutions") {
    return (
      <div className="mainnavlink">
        <SubMenuList
          blok={blok}
          links={[
            {
              icon: <CalendarRange size={32} />,
              name: "Peer to peer events",
              url: "/solutions/peer-to-peer-events",
              description:
                "When nonprofits put real muscle behind their fundraising events, their volunteer fundraisers raise more",
            },
            {
              icon: <FoldHorizontal size={32} />,
              name: "Personal fundraising",
              url: "/solutions/peer-to-peer-fundraising",
              description:
                "Hand fundraisers the keys to build their campaign, their way",
            },
            {
              icon: <Bike size={32} />,
              name: "Fitness fundraising",
              url: "/solutions/fitness-fundraising",
              description:
                "Fitness fundraising doesn’t have to be 5Ks and clipboard pledges anymore.",
            },
          ]}
          setShowMobile={setShowMobile}
        />
      </div>
    );
  }
  if (blok.link.story.name === "Platform") {
    return (
      <div className="mainnavlink">
        <SubMenuList
          blok={blok}
          links={[
            {
              icon: <Cog size={32} />,
              name: "Non-profit features",
              url: "/platform/nonprofit-features",
              description:
                "Catalyst doesn't just deliver the basics—it unleashes your full potential for impact.",
            },
            {
              icon: <Award size={32} />,
              name: "Fundraiser features",
              url: "/platform/fundraiser-features",
              description:
                "Industry-leading features, help to raise more per fundraiser than any other platform",
            },
            {
              icon: <ChevronsLeftRightEllipsis size={32} />,
              name: "Integrations",
              url: "/platform/integrations",
              description:
                "Let's make life easier for everyone with Catalyst's integrations.",
            },
          ]}
          setShowMobile={setShowMobile}
        />
      </div>
    );
  }

  return (
    <div className="mainnavlink">
      <Link
        to={`/${blok.link.cached_url}`}
        {...storyblokEditable(blok)}
        onClick={() => setShowMobile(false)}
      >
        {blok.link.story.name}
      </Link>
    </div>
  );
};

const SubMenuList = ({ blok, links, setShowMobile }) => {
  return (
    <div className="menu-dropdown">
      <Link
        to={`/${blok.link.cached_url}`}
        {...storyblokEditable(blok)}
        className="menu-dropdown-button"
        onClick={() => setShowMobile(false)}
      >
        {blok.link.story.name}
        <ChevronDown size={20} />
      </Link>
      <div className="menu-dropdown-content">
        {links.map((link, index) => {
          return (
            <Link
              to={link.url}
              key={index}
              onClick={() => setShowMobile(false)}
            >
              <div>{link.icon}</div>
              <div>
                <div className="page-name">{link.name}</div>
                <div className="page-desc">{link.description}</div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default MenuLink;
